module.exports = __webpack_public_path__ + "img/스나이퍼.f1efedd5.png";